import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon, BookOpenIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PriceOffer() {
  return <section className="py-20 px-4 bg-white" data-id="element-57">
      <div className="max-w-4xl mx-auto" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-59">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-6" data-id="element-60">
            Introducing: THE NAIL BUSINESS BLUEPRINT{' '}
            <span className="text-rose-500" data-id="element-61">(USA EDITION)</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-62">
            The step-by-step system that takes you from "Zero Knowledge" to
            "Booked-Out Pro" in record time.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/cWhMiazjy4tpbBGQ1jYAcM/nail_biz_sales_page.png" alt="Nail Biz Blueprint - Complete System with Ebook, Video Training, and Bonuses" className="w-full rounded-3xl shadow-2xl" data-id="element-64" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-900 rounded-3xl overflow-hidden shadow-2xl" data-id="element-65">
          <div className="p-8 md:p-12" data-id="element-66">
            <h3 className="text-2xl font-bold text-white mb-8 border-b border-slate-700 pb-4" data-id="element-67">
              What you're getting TODAY:
            </h3>

            <div className="space-y-6 mb-10" data-id="element-68">
              <div className="flex items-start gap-4" data-id="element-69">
                <div className="bg-rose-500/20 p-3 rounded-xl shrink-0" data-id="element-70">
                  <BookOpenIcon className="w-6 h-6 text-rose-400" data-id="element-71" />
                </div>
                <div data-id="element-72">
                  <h4 className="text-lg font-bold text-white flex items-center gap-2" data-id="element-73">
                    Nail Biz Mastery Main Ebook (60 pages)
                  </h4>
                  <p className="text-slate-400 mt-1" data-id="element-74">
                    Professional technique, product chemistry, and anatomy.
                  </p>
                  <p className="text-rose-400 text-sm font-semibold mt-2" data-id="element-75">
                    Value: $34
                  </p>
                </div>
              </div>

              <div className="bg-rose-500/10 border border-rose-500/30 rounded-2xl p-6" data-id="element-76">
                <div className="flex items-center gap-2 mb-6" data-id="element-77">
                  <GiftIcon className="w-6 h-6 text-rose-400" data-id="element-78" />
                  <h4 className="text-xl font-bold text-white" data-id="element-79">
                    FREE BONUSES INCLUDED TODAY
                  </h4>
                </div>

                <div className="space-y-4" data-id="element-80">
                  <div className="flex items-start gap-3" data-id="element-81">
                    <CheckIcon className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-82" />
                    <div className="flex-1" data-id="element-83">
                      <p className="text-white font-semibold" data-id="element-84">
                        USA Nail License State-by-State Guide
                      </p>
                      <p className="text-rose-400 text-sm font-semibold" data-id="element-85">
                        Value: $97
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-86">
                    <CheckIcon className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-87" />
                    <div className="flex-1" data-id="element-88">
                      <p className="text-white font-semibold" data-id="element-89">
                        Nail Tech Tax Essentials (IRS Ready)
                      </p>
                      <p className="text-rose-400 text-sm font-semibold" data-id="element-90">
                        Value: $67
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3" data-id="element-91">
                    <CheckIcon className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-92" />
                    <div className="flex-1" data-id="element-93">
                      <p className="text-white font-semibold" data-id="element-94">
                        30 Days of TikTok Hooks for Nail Techs
                      </p>
                      <p className="text-rose-400 text-sm font-semibold" data-id="element-95">
                        Value: $47
                      </p>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-rose-500/30" data-id="element-96">
                    <p className="text-rose-400 text-lg font-bold" data-id="element-97">
                      Total Bonus Value: $211
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-slate-800 rounded-2xl p-8 text-center border border-slate-700 relative overflow-hidden" data-id="element-98">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-rose-500 to-pink-500" data-id="element-99" />

              <div className="space-y-4 mb-8" data-id="element-100">
                <p className="text-slate-400" data-id="element-101">
                  If you went to a technical school today, you'd pay between{' '}
                  <span className="line-through" data-id="element-102">$850 and $2,500</span> just for
                  enrollment.
                </p>
                <p className="text-slate-400" data-id="element-103">
                  Even if you bought my 3 bonuses separately, you'd invest{' '}
                  <span className="line-through" data-id="element-104">$211</span>.
                </p>
                <p className="text-rose-200 font-medium text-lg" data-id="element-105">
                  But today, because I want this to be the year you finally
                  achieve financial independence in the United States... you
                  won't pay that. You won't even pay the{' '}
                  <span className="line-through" data-id="element-106">$34</span> for the main book.
                </p>
              </div>

              <div className="mb-8" data-id="element-107">
                <p className="text-white font-bold mb-2 uppercase tracking-wider text-sm" data-id="element-108">
                  Get the Entire System + All 3 Bonuses today for only:
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-109">
                  <span className="text-6xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-rose-400 to-pink-500" data-id="element-110">
                    $6.36
                  </span>
                  <span className="text-xl text-slate-400 font-medium mt-4" data-id="element-111">
                    USD
                  </span>
                </div>
                <p className="text-rose-400 text-sm font-medium mt-2" data-id="element-112">
                  (One-time payment. Lifetime access)
                </p>
              </div>

              <CTAButton size="xl" fullWidth id="price-offer-cta" href="https://www.consejossimples.com/cart/53597198778701:1" data-id="element-113">
                YES, I WANT MY FREEDOM
              </CTAButton>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}